var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoice = function SvgVoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.5 5.5v1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.5 3.855v4.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 2.43v7.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.5 1v10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.5 2.43v7.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 3.855v4.29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#voice_svg__g)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.5 5v2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__a",
    x1: 2,
    x2: 2,
    y1: 5.5,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__b",
    x1: 5,
    x2: 5,
    y1: 3.855,
    y2: 8.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__c",
    x1: 8,
    x2: 8,
    y1: 2.43,
    y2: 9.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__d",
    x1: 11,
    x2: 11,
    y1: 1,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__e",
    x1: 14,
    x2: 14,
    y1: 2.43,
    y2: 9.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__f",
    x1: 17,
    x2: 17,
    y1: 3.855,
    y2: 8.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice_svg__g",
    x1: 20,
    x2: 20,
    y1: 5,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8998"
  })))));
};
export default SvgVoice;